<div class="changelog">
  <div class="header">
    <hyperkit-typography variant="h3" align="left" color="primary">
      {{ release.version }}</hyperkit-typography
    >
    <hyperkit-typography
      variant="emphasized"
      size="sm"
      align="left"
      color="body"
    >
      {{ parseDate(release.version) }}</hyperkit-typography
    >
  </div>
  <hyperkit-markdown
    [md]="release.changelog"
    color="primary"
  ></hyperkit-markdown>
</div>
